import React, { useRef, useState, useEffect } from 'react';
import * as R from 'ramda';
import contriesList from 'iso-3166-1-alpha-2';
import { RegexFields } from '../../../constants/utils/regexFields';
import Address from '../../../constants/models/address';
import * as Loadings from '../../../constants/loadings/backoffice/partners';
import { CreatePartner, UpdatePartner, UploadPartnerLogo, DownloadPartnerLogo } from '../../../actions/backoffice/partners';
import { useDispatch } from 'react-redux';
import $ from 'jquery';
import { humanFileSize } from '../../../utils/misc';
import { PostalCityInput } from "../../../_common/postalCityInput";

export const AddPartner = ({ isLoading, partner }) => {
	const dispatch = useDispatch();
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

	const formRef = useRef();
	const inputFile = useRef(null);



	function resetForm() {
		formRef.current.classList.remove('was-validated');
		if (R.isNil(partner)) {
			setPartnerInfo({
				name: '',
				fullyQualifiedName: '',
				vatNumber: '',
				siret: '',
				isEnabled: true,
				billingFrequencyInMonths: 1,
				personalization: undefined,
				setupFee: 0,
				partnerInitialReduction: 0,
				partnerInitialPercentage: 0,
				partnerRecurentReduction: 0,
				partnerRecurentPercentage: 0,
				plateformInitialReduction: 0,
				plateformInitialPercentage: 0,
				plateformRecurentReduction: 0,
				plateformRecurentPercentage: 0,
				addressDataTransferObject: new Address(),
				color: '',
			});
		} else {
			setPartnerInfo({ ...partner });
		}

	}

	let initPartnerFormValues = {
		name: '',
		fullyQualifiedName: '',
		vatNumber: '',
		siret: '',
		isEnabled: true,
		billingFrequencyInMonths: 1,
		personalization: undefined,
		setupFee: 0,
		partnerInitialReduction: 0,
		partnerInitialPercentage: 0,
		partnerRecurentReduction: 0,
		partnerRecurentPercentage: 0,
		plateformInitialReduction: 0,
		plateformInitialPercentage: 0,
		plateformRecurentReduction: 0,
		plateformRecurentPercentage: 0,
		addressDataTransferObject: new Address(),
		color: '',
	};

	if (!R.isNil(partner)) {
		initPartnerFormValues = { ...partner };
	}

	const [logo, setLogo] = useState(undefined);
	const [partnerInfo, setPartnerInfo] = useState(initPartnerFormValues);

	const [showDroits, setShowDroits] = useState(partnerInfo.setupFee === 0 ? false : true);
	const [widthIsBigger, setWidthIsBigger] = useState(false);

	useEffect(() => {
		if (!R.isNil(partnerInfo.profilePicture)) {
			let i = new Image();
			i.onload = function () {
				setWidthIsBigger(i.width > i.height);
			};
			i.src = partnerInfo.profilePicture;
		}
	}, [partnerInfo.profilePicture]);

	useEffect(() => {
		const logoPreview = document.getElementById("logo-preview");
		if (!R.isNil(partner) && !R.isNil(logoPreview)) {
			setPartnerInfo({ ...partner });
			if (partner.hasLogo) {
				DownloadPartnerLogo(partner.id)
					.then((file) => {
						setLogo(file);
						logoPreview.src = URL.createObjectURL(file);
						logoPreview.classList.remove("d-none");
					});
			}

		}
		// if (!R.isNil(partnerInfo.profilePicture)) {
		// 	let i = new Image();
		// 	i.onload = function () {
		// 		setWidthIsBigger(i.width > i.height);
		// 	};
		// 	i.src = partnerInfo.profilePicture;
		// }
	}, [partner]);


	return (
		<div className="modal fade px-0" id="AddPartner" aria-labelledby="AddPartnerLabel" aria-hidden="true">
			<div className="modal-dialog modal-lg px-2">
				<div className="modal-content">
					<header className="modal-header">
						{R.isNil(partnerInfo.id) || partnerInfo.id === "" ? (
							<div className="alert bg-alert-info rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">Add partner</h1>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 text-info text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="AddPartnerLabel">
										ajouter un nouveau Partenaire
									</div>
									<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
										<i className="eva eva-close fs-4"></i>
									</button>
								</div>
							</div>
						) : (
							<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">Edit partner</h1>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="EditPartnerLabel">
										Paramètres du Partenaire
									</div>
									<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
										<i className="eva eva-close fs-4"></i>
									</button>
								</div>
							</div>
						)}
					</header>
					<div className="modal-body scroll-default pt-0">
						<form noValidate ref={formRef} autoComplete="off">
							<section className="block">
								<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2">Partenaire *</h4>
								<div className="block">
									<div className="form-row">
										<div className="col-md-4">
											<div className="form-group">
												<label className="h6 font-weight-bolder my-auto" htmlFor="nomPartenaire">
													Nom du partenaire
												</label>
												<input required type="text" className="form-control" id="nomPartenaire" value={partnerInfo.name} onChange={(e) => setPartnerInfo({ ...partnerInfo, name: e.target.value })} />
											</div>
											<div className="form-group">
												<label className="h6 font-weight-bolder my-auto" htmlFor="nomPartenaire">
													Email de facturation
												</label>
												<input required type="text" className="form-control" id="nomPartenaire" value={partnerInfo.email} onChange={(e) => setPartnerInfo({ ...partnerInfo, email: e.target.value })} />
											</div>
										</div>
										<div className="col">
											<div className="form-group">
												<label className="h6 font-weight-bolder my-auto" htmlFor="AddressLine1Input">
													Adresse ligne 1
												</label>
												<input
													required
													type="text"
													className="form-control"
													id="AddressLine1Input"
													placeholder="Adresse de l'entreprise"
													value={partnerInfo.addressDataTransferObject.addressLine1}
													onChange={(e) => setPartnerInfo({ ...partnerInfo, addressDataTransferObject: { ...partnerInfo.addressDataTransferObject, addressLine1: e.target.value } })}
												/>
												<div className="invalid-feedback">
													<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
													<span className="align-middle text-dark o-70">Ce champ est requis</span>
												</div>
											</div>
											<div className="form-group">
												<label className="label h6 font-weight-bold my-auto" htmlFor="AddressLine2Input">
													Adresse ligne 2
												</label>
												<input
													type="text"
													className="form-control rounded"
													id="AddressLine2Input"
													placeholder="(optionnel)"
													value={partnerInfo.addressDataTransferObject.addressLine2}
													onChange={(e) => setPartnerInfo({ ...partnerInfo, addressDataTransferObject: { ...partnerInfo.addressDataTransferObject, addressLine2: e.target.value } })}
												/>
											</div>
											<div className="form-row">
												<PostalCityInput
													postalCode={partnerInfo.addressDataTransferObject.postalCode}
													city={partnerInfo.addressDataTransferObject.city}
													onChange={(updatedAddress) => setPartnerInfo({ ...partnerInfo, addressDataTransferObject: { ...partnerInfo.addressDataTransferObject, postalCode: updatedAddress.postalCode, city: updatedAddress.city } })}
													hasWrapper={false}
													country={partnerInfo.addressDataTransferObject.country}
													customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
												/>
												{/* <div className="form-group col-12 col-sm-6 col-lg">
													<label className="h6 font-weight-bolder my-auto" htmlFor="AddressZipCodeInput">
														Code Postal
													</label>
													<input
														required
														type="text"
														className="form-control"
														id="AddressZipCodeInput"
														placeholder="ex: 75001"
														value={partnerInfo.addressDataTransferObject.postalCode}
														onChange={(e) => setPartnerInfo({ ...partnerInfo, addressDataTransferObject: { ...partnerInfo.addressDataTransferObject, postalCode: e.target.value } })}
													/>
													<div className="invalid-feedback">
														<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
														<span className="align-middle text-dark o-70">Ce champ est requis</span>
													</div>
												</div>
												<div className="form-group col-12 col-sm-6 col-lg">
													<label className="h6 font-weight-bolder my-auto" htmlFor="AddressCityInput">
														Ville
													</label>
													<input
														required
														type="text"
														className="form-control"
														id="AddressCityInput"
														placeholder="ex: Paris"
														value={partnerInfo.addressDataTransferObject.city}
														onChange={(e) => setPartnerInfo({ ...partnerInfo, addressDataTransferObject: { ...partnerInfo.addressDataTransferObject, city: e.target.value } })}
													/>
													<div className="invalid-feedback">
														<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
														<span className="align-middle text-dark o-70">Ce champ est requis</span>
													</div>
												</div> */}
												<div className="form-group col-12 col-sm-6 col-lg">
													<label className="h6 font-weight-bolder my-auto" htmlFor="AddressCountrySelect">
														Pays
													</label>
													<select className="custom-select" id="AddressCountrySelect" value={partnerInfo.addressDataTransferObject.country} onChange={(e) => setPartnerInfo({ ...partnerInfo, addressDataTransferObject: { ...partnerInfo.addressDataTransferObject, country: e.target.value } })}>
														{Object.keys(contriesList.getData()).map((country, idx) => {
															return (
																<option key={idx} value={country}>
																	{countries.getName(country, "fr", { select: "official" })}
																</option>
															);
														})}
													</select>
												</div>
											</div>
										</div>
									</div>
									<div className="form-row">
										<div className="col-md">
											<div className="form-group">
												<label className="h6 font-weight-bolder" htmlFor="FullyQualifiedNameInput">
													Raison Sociale
												</label>
												<input required type="text" className="form-control" id="FullyQualifiedNameInput" value={partnerInfo.fullyQualifiedName} onChange={(e) => setPartnerInfo({ ...partnerInfo, fullyQualifiedName: e.target.value })} />
											</div>
										</div>
										<div className="col-md">
											<div className="form-group">
												<label className="h6 font-weight-bolder" htmlFor="VatNumberInput">
													TVA
												</label>
												<input required type="text" className="form-control" id="VatNumberInput" value={partnerInfo.vatNumber} onChange={(e) => setPartnerInfo({ ...partnerInfo, vatNumber: e.target.value })} pattern={RegexFields.vatNumbers} />
											</div>
										</div>
										<div className="col-md">
											<div className="form-group">
												<label className="h6 font-weight-bolder" htmlFor="SiretInput">
													SIRET
												</label>
												<input required type="text" className="form-control" id="SiretInput" value={partnerInfo.siret} onChange={(e) => setPartnerInfo({ ...partnerInfo, siret: e.target.value })} />
											</div>
										</div>
									</div>
								</div>
								<div className="block mt-1">
									<hr className="my-3" />
									<div className="flex-row align-items-center mt-sm mb-3">
										<h5 className="h4 text-uppercase text-secondary font-weight-bolder mr-auto my-auto">Réductions et commissions</h5>
									</div>
									<div className="block p-sm bg-light rounded">
										<div className="row g-2">
											<div className="col-md">
												<h6 className="h5 font-weight-bold text-uppercase o-80">Paiements directement au partenaire</h6>
												<div className="form-row">
													<div className="col">
														<div className="form-group">
															<label className="h6 font-weight-bolder" htmlFor="FraisInt">
																Réduction Dossier
															</label>
															<div className="input-group">
																<input required type="text" className="form-control" id="FraisInt" value={partnerInfo.partnerInitialReduction} onChange={(e) => setPartnerInfo({ ...partnerInfo, partnerInitialReduction: e.target.value })} />
																<div className="input-group-append">
																	<span className="input-group-text" id="basic-addon2">
																		%
																	</span>
																</div>
															</div>
														</div>
													</div>
													<div className="col">
														<div className="form-group">
															<label className="h6 font-weight-bolder" htmlFor="CommissionsInt">
																Commission Dossier
															</label>
															<div className="input-group">
																<input required type="text" className="form-control" id="CommissionsInt" value={partnerInfo.partnerInitialPercentage} onChange={(e) => setPartnerInfo({ ...partnerInfo, partnerInitialPercentage: e.target.value })} />
																<div className="input-group-append">
																	<span className="input-group-text" id="basic-addon2">
																		%
																	</span>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="form-row">
													<div className="col">
														<div className="form-group">
															<label className="h6 font-weight-bolder" htmlFor="FraisInt">
																Réduction Actualisation
															</label>
															<div className="input-group">
																<input required type="text" className="form-control" id="FraisInt" value={partnerInfo.partnerRecurentReduction} onChange={(e) => setPartnerInfo({ ...partnerInfo, partnerRecurentReduction: e.target.value })} />
																<div className="input-group-append">
																	<span className="input-group-text" id="basic-addon2">
																		%
																	</span>
																</div>
															</div>
														</div>
													</div>
													<div className="col">
														<div className="form-group">
															<label className="h6 font-weight-bolder" htmlFor="CommissionsInt">
																Commission Actualisation
															</label>
															<div className="input-group">
																<input required type="text" className="form-control" id="CommissionsInt" value={partnerInfo.partnerRecurentPercentage} onChange={(e) => setPartnerInfo({ ...partnerInfo, partnerRecurentPercentage: e.target.value })} />
																<div className="input-group-append">
																	<span className="input-group-text" id="basic-addon2">
																		%
																	</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="d-none d-md-flex col-md-auto align-items-center">
												<hr className="divider-vertical h-100" />
											</div>
											<div className="col-md">
												<h6 className="h5 font-weight-bold text-uppercase o-80">Paiements via la plateforme</h6>
												<div className="form-row">
													<div className="col">
														<div className="form-group">
															<label className="h6 font-weight-bolder" htmlFor="FraisExt">
																Réduction Dossier
															</label>
															<div className="input-group">
																<input required type="text" className="form-control" id="FraisExt" value={partnerInfo.plateformInitialReduction} onChange={(e) => setPartnerInfo({ ...partnerInfo, plateformInitialReduction: e.target.value })} />
																<div className="input-group-append">
																	<span className="input-group-text" id="basic-addon2">
																		%
																	</span>
																</div>
															</div>
														</div>
													</div>
													<div className="col">
														<div className="form-group">
															<label className="h6 font-weight-bolder" htmlFor="CommissionsExt">
																Commissions Dossier
															</label>
															<div className="input-group">
																<input required type="text" className="form-control" id="CommissionsExt" value={partnerInfo.plateformInitialPercentage} onChange={(e) => setPartnerInfo({ ...partnerInfo, plateformInitialPercentage: e.target.value })} />
																<div className="input-group-append">
																	<span className="input-group-text" id="basic-addon2">
																		%
																	</span>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="form-row">
													<div className="col">
														<div className="form-group">
															<label className="h6 font-weight-bolder" htmlFor="FraisInt">
																Réduction Actualisation
															</label>
															<div className="input-group">
																<input required type="text" className="form-control" id="FraisInt" value={partnerInfo.plateformRecurentReduction} onChange={(e) => setPartnerInfo({ ...partnerInfo, plateformRecurentReduction: e.target.value })} />
																<div className="input-group-append">
																	<span className="input-group-text" id="basic-addon2">
																		%
																	</span>
																</div>
															</div>
														</div>
													</div>
													<div className="col">
														<div className="form-group">
															<label className="h6 font-weight-bolder" htmlFor="CommissionsInt">
																Commission Actualisation
															</label>
															<div className="input-group">
																<input required type="text" className="form-control" id="CommissionsInt" value={partnerInfo.plateformRecurentPercentage} onChange={(e) => setPartnerInfo({ ...partnerInfo, plateformRecurentPercentage: e.target.value })} />
																<div className="input-group-append">
																	<span className="input-group-text" id="basic-addon2">
																		%
																	</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="form-group w-xl-75">
											<label className="h6 font-weight-bolder" htmlFor="frequenceFacturationInt">
												Fréquence de facturation
											</label>
											<select className="form-control custom-select" id="frequenceFacturationInt" aria-label="Default select example" value={partnerInfo.billingFrequencyInMonths} onChange={(e) => setPartnerInfo({ ...partnerInfo, billingFrequencyInMonths: e.target.value })}>
												{[...Array(13)].map((x, i) => {
													if (i === 0) return "";
													return (
														<option key={i} value={i}>
															Tous les {i} mois
														</option>
													);
												})}
											</select>
										</div>
									</div>
								</div>
								<div className="block mt-1">
									<hr className="my-3" />
									<div className="flex-row align-items-center my-sm">
										<div className="mr-auto my-auto">
											<h5 className={"h4 text-uppercase text-secondary font-weight-bolder my-auto"}>Personnalisation</h5>
											{/* <p className="o-60 fs-3 mb-0">Activer ou désactiver l'utilisateur de ce partenaire</p> */}
										</div>
										<div className="flex-row ml-auto align-items-center">
											{/* <div className="form-inline mb-3"> */}
											<div className="custom-control custom-radio custom-control-inline">
												<input required={R.isNil(partnerInfo.personalization) ? true : false} type="radio" id="OuiPersonnalisation" name="Personnalisation" onClick={() => setPartnerInfo({ ...partnerInfo, personalization: true })} className="custom-control-input" defaultChecked={partnerInfo.personalization === true} />
												<label className="custom-control-label" htmlFor="OuiPersonnalisation">
													Oui
												</label>
											</div>
											<div className="custom-control custom-radio custom-control-inline mr-0">
												<input
													required={R.isNil(partnerInfo.personalization) ? true : false}
													type="radio"
													id="NonPersonnalisation"
													name="Personnalisation"
													onClick={() => {
														setPartnerInfo({ ...partnerInfo, personalization: false, color: undefined });
														setLogo(undefined);
													}}
													className="custom-control-input"
													defaultChecked={partnerInfo.personalization === false}
												/>
												<label className="custom-control-label" htmlFor="NonPersonnalisation">
													Non
												</label>
											</div>
										</div>
									</div>
									{partnerInfo.personalization ? (
										<div className="container-wide mb-sm">
											<p className="o-60 fs-3">Définissez ci-dessous le logo de votre entreprise et les couleurs visibles par vos clients</p>
											{/* <hr className="my-sm" /> */}
											<div className="card card-body bg-light rounded">
												<div className="form-row gx-1">
													<div className="form-group col mb-0 flex-column">
														<label className="h6 font-weight-bolder mb-1" htmlFor="logo">
															Logo
														</label>
														<small id="colorHelpBlock" className="form-text text-muted mt-nborder mb-xs">
															Cliquez ci-dessous pour ajouter le logo.
														</small>
														<div className="flex-row my-auto" id="logo">
															<div className={"d-flex h-6 w-6 rounded font-weight-bold bg-white border-faded border"} role="button" onClick={() => inputFile.current.click()}>
																<input
																	type="file"
																	id="file"
																	accept="image/*"
																	ref={inputFile}
																	style={{ display: "none" }}
																	onChange={(e) => {
																		setLogo(e.target.files[0]);
																		document.getElementById("logo-preview").src = URL.createObjectURL(e.target.files[0]);
																		document.getElementById("logo-preview").classList.remove("d-none");
																	}}
																/>
																<img className={"img-fluid h-100 w-100 rounded-inherit img-cover d-none"} id="logo-preview" alt="avatar" src="#" />
																{R.isNil(logo) ? <i className="eva eva-image-2 h2 lh-1 m-auto icon-default"></i> : ""}
																{/* {!R.isNil(partnerInfo.profilePicture) ?
																	<img className={"img-fluid h-100 w-100 rounded-inherit" + (widthIsBigger ? ' img-contain bg-white border' : ' img-cover')} alt="avatar" src={partnerInfo.profilePicture} /> :
																	<i className="eva eva-image-2 h2 lh-1 m-auto icon-default"></i>
																} */}
															</div>
															{!R.isNil(logo) ? (
																<div className="ml-3 my-auto">
																	<div className="h6 font-weight-bolder mb-0">
																		{logo.name}{" "}
																		<i
																			className="eva eva-close fs-3"
																			role="button"
																			onClick={() => {
																				setLogo(undefined);
																				document.getElementById("logo-preview").classList.add("d-none");
																			}}></i>
																	</div>
																	<p className="o-60 fs-2 my-0">{humanFileSize(logo.size)}</p>
																</div>
															) : (
																<div className="ml-3 my-auto">
																	<div className="h6 mb-0 o-80">Aucun fichier ajouté</div>
																	<p className="o-60 fs-2 my-0">0 kbs</p>
																</div>
															)}
														</div>
													</div>
													<div className="form-group col mb-0 flex-column">
														<label className="h6 font-weight-bolder mb-1" htmlFor="color">
															Couleur du menu
														</label>
														<small id="colorHelpBlock" className="form-text text-muted mt-nborder mb-xs">
															Veuillez renseigner la couleur au format HEX.
														</small>
														<div className="input-group">
															<div className="input-group-prepend">
																<span className="input-group-text" id="basic-addon2">
																	#
																</span>
															</div>
															<input
																required
																pattern="^([0-9a-fA-F]{3}){1,2}$"
																type="text"
																className="form-control border-faded my-auto"
																id="color"
																placeholder="000000"
																value={partnerInfo.color}
																onChange={(e) => {
																	setPartnerInfo({ ...partnerInfo, color: e.target.value });
																}}
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									) : (
										""
									)}
								</div>

								<div className="block mt-1">
									<hr className="my-3" />
									<div className="flex-row align-items-center my-sm">
										<div className="mr-auto my-auto">
											<h5 className={"h4 text-uppercase text-secondary font-weight-bolder my-auto"}>DROITS D’ENTRÉE</h5>
										</div>
										<div className="flex-row ml-auto align-items-center">
											{/* <div className="form-inline mb-3"> */}
											<div className="custom-control custom-radio custom-control-inline">
												<input required={showDroits === undefined ? true : false} type="radio" id="OuiDroits" name="Droits" onClick={() => setShowDroits(true)} onChange={() => {}} className="custom-control-input" defaultChecked={showDroits === true} />
												<label className="custom-control-label" htmlFor={"OuiDroits"}>
													Oui
												</label>
											</div>
											<div className="custom-control custom-radio custom-control-inline mr-0">
												<input required={showDroits === undefined ? true : false} type="radio" id="NonDroits" name="Droits" onClick={() => setShowDroits(false)} onChange={() => {}} className="custom-control-input" defaultChecked={showDroits === false} />
												<label className="custom-control-label" htmlFor={"NonDroits"}>
													Non
												</label>
											</div>
										</div>
									</div>
									{showDroits ? (
										<div className="block p-sm bg-light rounded mb-3">
											<div className="form-row">
												<div className="form-group col-3">
													<label className="h6 font-weight-bolder" htmlFor="SetupFeeInput">
														Montant
													</label>
													<div className="input-group">
														<input required type="text" className="form-control" id="SetupFeeInput" value={partnerInfo.setupFee} onChange={(e) => setPartnerInfo({ ...partnerInfo, setupFee: e.target.value })} />
														<div className="input-group-append">
															<span className="input-group-text" id="basic-addon2">
																€
															</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									) : (
										""
									)}
								</div>
							</section>
							{/* <section className="block mt-6">
								<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2">Données d'Admin *</h4>
								<div className="block p-sm bg-light rounded mb-3">
									<div className="form-row">
										<div className="form-group col">
											<label className="h6 font-weight-bolder" htmlFor="PrenomNom">Nom</label>
											<input required type="text" className="form-control" id="PrenomNom" />
										</div>
										<div className="form-group col">
											<label className="h6 font-weight-bolder" htmlFor="PrenomNom">Prénom</label>
											<input required type="text" className="form-control" id="PrenomNom" />
										</div>
										<div className="form-group col">
											<label className="h6 font-weight-bolder" htmlFor="poste">Intitulé du poste</label>
											<select className="form-control custom-select" id="poste" aria-label="Default select example">
												<option selected>Choose the role...</option>
												<option value="Admin">Admin</option>
											</select>
										</div>
									</div>
									<div className="form-row">
										<div className="form-group col">
											<label className="h6 font-weight-bolder" htmlFor="Email">Email</label>
											<input required type="email" className="form-control" id="Email" />
										</div>
										<div className="form-group col">
											<label className="h6 font-weight-bolder" htmlFor="Phone">Phone</label>
											<input required type="email" className="form-control" id="Phone" />
										</div>
									</div>
								</div>
							</section> */}
						</form>
					</div>
					<div className="modal-footer pt-0">
						<button type="button" className="btn btn-faded" data-dismiss="modal" onClick={(e) => resetForm()}>
							Fermer
						</button>
						{isLoading.includes(Loadings.CREATING_PARTNER) ? (
							<button type="button" className="btn btn-info loading-btn show">
								<div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Enregistrer
							</button>
						) : (
							<button
								type="button"
								className="btn btn-info"
								onClick={(e) => {
									e.preventDefault();
									if (formRef.current.checkValidity()) {
										if (R.isNil(partnerInfo.id) || partnerInfo.id === "") {
											dispatch(CreatePartner(partnerInfo))
												.then((partner) => {
													if (!R.isNil(logo)) {
														dispatch(UploadPartnerLogo(partner.id, logo));
													}
													Promise.resolve();
												})
												.then(() => {
													$(".modal").modal("hide");
													resetForm();
												});
										} else {
											dispatch(UpdatePartner(partnerInfo))
												.then((partner) => {
													if (!R.isNil(logo)) {
														dispatch(UploadPartnerLogo(partner.id, logo));
													}
													Promise.resolve();
												})
												.then(() => {
													$(".modal").modal("hide");
													resetForm();
												});
										}
									}
									formRef.current.classList.add("was-validated");
								}}>
								Enregistrer
							</button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};